import { useRef } from 'react';
import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';

import { env } from '@/env';
import { Modal } from '@/modules/modals';
import { Heading, Loadable, Text } from '@/modules/ui';

import { useSubscriptionUpgradeModal } from '../../hooks';
import { useCheckout, useGetIframeUrl, useIframeDimensions, useReceiveIframeMessages } from './hooks';
import * as felaRules from './SubscriptionUpgradeModal.rules';

export const SubscriptionUpgradeModal = () => {
    const { css } = useFela();
    const { formatMessage } = useIntl();

    const { isOpen, closeUpgradeModal } = useSubscriptionUpgradeModal();

    const iframeRef = useRef<HTMLIFrameElement>(null);
    const iframeContainerRef = useRef<HTMLDivElement>(null);
    const { iframeHeight } = useIframeDimensions(iframeContainerRef);
    const iframeUrl = useGetIframeUrl();

    const { checkout, isPending } = useCheckout();
    useReceiveIframeMessages(checkout);

    return (
        <Modal
            open={isOpen}
            width='100%'
            zIndex={2000}
            closable
            onClose={closeUpgradeModal}
            extend={{ container: felaRules.modalContainer }}
        >
            <div className={css(felaRules.contentContainer)}>
                {env.VITE_DEMO && (
                    <div className={css(felaRules.textContainer)}>
                        <Heading elementType='h2' variant='h1' color='black'>
                            <FormattedMessage id='saas.upgradeModal.title' />
                        </Heading>
                        <Text variant='ParagraphSmallMedium' color='foregroundsTertiary'>
                            <FormattedMessage id='saas.upgradeModal.text' />
                        </Text>
                    </div>
                )}

                <div className={css(felaRules.iframeContainer)} ref={iframeContainerRef}>
                    <Loadable showLoader={isPending}>
                        <iframe
                            className={css(felaRules.iframe)}
                            height={iframeHeight}
                            src={iframeUrl}
                            title={formatMessage({ id: 'saas.upgradeModal.pricingPlans.title' })}
                            width='100%'
                            ref={iframeRef}
                        />
                    </Loadable>
                </div>
            </div>
        </Modal>
    );
};
